import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Modal, Icon } from "antd";

export default class MyModal extends PureComponent {
  static propTypes = {
    type: PropTypes.oneOf(["default", "full", "custom"]),
  };

  static defaultProps = {
    type: "default",
  };
  render() {
    const {
      className,
      type,
      backgroundColor = "#40066c",
      backgroundOpacity = 0.96,
    } = this.props;
    return (
      <Modal
        {...this.props}
        className={`${className} type-${type}`}
        footer={null}
      >
        {type === "default" && (
          <React.Fragment>
            <div className="body-default">
              <div className="close-button" onClick={this.props.onCancel}>
                <i className="fa fa-times" />
              </div>
              <div className="content">{this.props.children}</div>
            </div>
          </React.Fragment>
        )}
        {type === "full" && (
          <React.Fragment>
            <div
              className="bg"
              style={{
                backgroundColor: backgroundColor,
                opacity: backgroundOpacity,
              }}
            />
            <div className="body">
              <div className="container">
                <div className="close-btn" onClick={this.props.onCancel}>
                  <Icon type="close" />
                </div>
                <div className="content">{this.props.children}</div>
              </div>
            </div>
          </React.Fragment>
        )}
        {type === "custom" && (
          <React.Fragment>
            <div
              className="bg"
              style={{
                backgroundColor: backgroundColor,
                opacity: backgroundOpacity,
              }}
            />
            <div className="body">
              <div className="container">
                <div className="content">
                  {this.props.children}
                  <div
                    className="close-btn-absolute"
                    onClick={this.props.onCancel}
                  >
                    <Icon type="close" />
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal.js